import React from "react";

interface SpacerProps {
}

class Spacer extends React.Component<SpacerProps> {
    render() {
        return (
            <span className="spacer"></span>
        );
    }
}

export default Spacer;
